import { render, staticRenderFns } from "./IconJustifyRight.vue?vue&type=template&id=460d3c5c&"
import script from "./IconJustifyRight.vue?vue&type=script&lang=js&"
export * from "./IconJustifyRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports